(function() {
	'use strict';
	angular.module('app.leanProjects')
		.controller('issueForm', issueForm);

	issueForm.$inject = ['$scope', '$timeout', '$filter', 'issueFormService', 'newProjectService', 'leanProjectAuthService'];
	function issueForm($scope, $timeout, $filter, issueFormService, newProjectService, leanProjectAuthService) {
		var vm = this;
		// view model functions
		vm.details = $scope.details;
		vm.projectNdx = $scope.projectNdx;
		vm.leanDirFactoryNdx = $scope.leanDirFactoryNdx;
		vm.action = $scope.action;
		vm.viewMode = $scope.viewMode;
		vm.changeMode = changeMode;
		vm.issue = {};
		vm.close = close;
		vm.save = save;
		vm.datePickerOpen = datePickerOpen;
		vm.dueDateAfterProjectDueDate = false;
		vm.dueDateChange = dueDateChange;
		vm.actionIsAllowed = actionIsAllowed;
		vm.filterManagers = filterManagers;
		vm.firstTimeEdit = true;
		vm.alternateUserList = [];
		vm.isSaveButtonDisabled = false;

		// 24hr after unix epoch, to avoid any timezone issues
		vm.minDate = new Date(86400000);

		init();

		function init() {
			// init view model project
			vm.isSupplier = globalConfig.user.role == 'Supplier';
			vm.issuePriorities = [{id: 'Low', text: 'Low'},{id: 'Medium', text: 'Medium'},{id: 'High', text: 'High'},{id: 'Critical', text: 'Critical'}];			
			vm.states = [{id: 'Pending', text: 'Pending'},{id: 'Completed', text: 'Completed'}];
			
			if (vm.action == 'Edit') {
				getIssue();
			} 
			else {
				getDropDownListsFromServer();
				vm.issue.projectedCompleteDate = moment().add(14, 'days').toDate();
				vm.issue.stateType = 'Pending';
				vm.issue.priorityType = 'Medium';
			}
		}
		
		function actionIsAllowed(action, responsibleNdx) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details, responsibleNdx);
		}
		
		function getIssue() {
			issueFormService.getIssue($scope.issue.ndx, vm.projectNdx, vm.leanDirFactoryNdx).then(function(issue) {
				issue.data.projectedCompleteDate = new Date(issue.data.projectedCompleteDate);
				var projectedCompleteDateLocal = moment(issue.data.projectedCompleteDate).add(issue.data.projectedCompleteDate.getTimezoneOffset(), 'minutes');
				issue.data.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
				vm.orignalIssue = jQuery.extend({},issue.data, true); 
				getDropDownListsFromServer(vm.orignalIssue);
				vm.issue = issue.data;
				dueDateChange();
			});
		}
		
		function getDropDownListsFromServer(issueObj) {
			var inactiveResponsibleUser = typeof issueObj !== 'undefined' && issueObj.responsibleStatus == 'inactive' ? issueObj.issueResponsibleId : null;
			newProjectService.getUsers(vm.leanDirFactoryNdx, inactiveResponsibleUser).then(function(users) {
				if (vm.action == 'Edit') {
					var filteredResults = [];
					angular.forEach(users, function(item) {
						if( item.id == vm.issue.issueResponsibleId) {
							filteredResults.push(item);
						}
					});
					vm.alternateUserList = filteredResults;
				}
				vm.issueManagers = users;
			});
		}

		function filterManagers(searchTerm) {
			if (vm.action == 'Edit' && vm.firstTimeEdit && searchTerm == '') {
				return vm.alternateUserList;
			} else {
				vm.firstTimeEdit = false;
				return newProjectService.filterUsers(vm.issueManagers, searchTerm);
			}
		}

		function cleanUpIssueObject() {
			var issueObj = jQuery.extend({}, vm.issue);
			delete issueObj.firstName;
			delete issueObj.lastName;
			delete issueObj.responsible;
			delete issueObj.responsibleStatus;
			return issueObj;
		}
		
		function save() {
			vm.isSaveButtonDisabled = true;
			if (typeof vm.issue.ndx === 'undefined') {
				issueFormService.createIssue(vm.issue, vm.projectNdx, $scope.leanDirFactoryNdx).then(function(message) {
					var projectedCompleteDateUtc = moment(vm.issue.projectedCompleteDate).subtract(vm.issue.projectedCompleteDate.getTimezoneOffset(), 'minutes');
					vm.issue.projectedCompleteDate = moment(projectedCompleteDateUtc)._d;
					updateProjectDueDate(message == 'leanProject.toast.createIssueSuccess');
					$scope.$emit('updateLastModified', {});
					$scope.result(message, message == 'leanProject.toast.createIssueSuccess');
					vm.isSaveButtonDisabled = false;
				});
			} else {
				var lastModified = (typeof vm.issue.lastModified === 'undefined') ? (new Date()).toUTCString(): (new Date(vm.issue.lastModified)).toUTCString();
				if (!angular.equals(vm.issue, vm.orignalIssue)) {
					
					var projectedCompleteDateUtc = moment(vm.issue.projectedCompleteDate).subtract(vm.issue.projectedCompleteDate.getTimezoneOffset(), 'minutes');
					vm.issue.projectedCompleteDate = moment(projectedCompleteDateUtc)._d;
					
					issueFormService.updateIssue(cleanUpIssueObject(vm.issue), $scope.projectNdx, $scope.leanDirFactoryNdx, lastModified).then(function(message) {
						updateProjectDueDate(message == 'leanProject.toast.updateIssueSuccess');
						$scope.$emit('updateLastModified', {});
						$scope.result(message, message == 'leanProject.toast.updateIssueSuccess');
						vm.isSaveButtonDisabled = false;
					});
				} else {
					$scope.result('', true);
					vm.isSaveButtonDisabled = false;
				}
			}
		}
		
		function close() {
			$scope.result('', false);
		}
		
		function datePickerOpen(type) {
			$timeout(function() {
				if (type === 'start') {
					vm.startDateOpened = true;
				} else {
					vm.endDateOpened = true;
				}
			});
		}
		
		function changeMode() {
			vm.viewMode = false;
		}
		
		function updateProjectDueDate(updateDate) {
			if (vm.dueDateAfterProjectDueDate && updateDate) {
				var projectedCompleteDateLocal = moment(vm.issue.projectedCompleteDate).add(vm.issue.projectedCompleteDate.getTimezoneOffset(), 'minutes');
				vm.issue.projectedCompleteDate = moment(projectedCompleteDateLocal)._d;
				vm.details.endDate = moment(vm.issue.projectedCompleteDate).valueOf();
			}
		}
		
		function dueDateChange() {
			var issueDate = moment(vm.issue.projectedCompleteDate);
			if (issueDate != null && issueDate.isValid()) {
	            var projectDate = moment(vm.details.endDate);
	            var result = (moment(issueDate).isAfter(projectDate, 'days'));
	            vm.dueDateAfterProjectDueDate = result;
			}
		}
	}
})();
